module.exports = __webpack_public_path__ + "img/SaveSearch.d42fdd35.svg";